import axios from 'axios';
import { CONFIG_SERVER } from '../constants/common.constant';

const { CLIENT_ID, AUTH_URL, BACKEND_URL, REALM_ID } = CONFIG_SERVER;

export const getAuthUrl = () => {
  const realmId = REALM_ID;
  return AUTH_URL + `/auth/realms/${realmId}/protocol/openid-connect/token`;
};

export const refreshToken = (refreshToken = '') => {
  const requestBody = new URLSearchParams();
  requestBody.append('grant_type', 'refresh_token');
  requestBody.append('client_id', CLIENT_ID);
  requestBody.append('refresh_token', refreshToken);
  requestBody.append('redirect_uri', window.location.origin);
  const realmId = REALM_ID;

  return axios({
    method: 'post',
    url: AUTH_URL + `/auth/realms/${realmId}/protocol/openid-connect/token`,
    data: requestBody,
  });
};

export const fetchTokenFromCode = (code = '', sessionState = '') => {
  const requestBody = new URLSearchParams();
  requestBody.append('grant_type', 'authorization_code');
  requestBody.append('client_id', CLIENT_ID);
  requestBody.append('code', code);
  requestBody.append('session_state', sessionState);
  requestBody.append('redirect_uri', window.location.origin);

  return axios({
    method: 'post',
    url: getAuthUrl(),
    data: requestBody,
  });
};

export const getTenantSetting = async () => {
  return await axios({
    method: 'GET',
    url: BACKEND_URL + '/ris/backend/tenant/setting',
    // headers: {
    //   'X-TENANT-ID': 'local',
    // },
  });
};

export const fetchPermissionToken = (token) => {
  const requestBody = new URLSearchParams();
  requestBody.append(
    'grant_type',
    'urn:ietf:params:oauth:grant-type:uma-ticket'
  );
  requestBody.append('audience', 'vindr-api');

  return axios({
    url: getAuthUrl(),
    method: 'post',
    data: requestBody,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
